import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import pink from '@material-ui/core/colors/pink';

let theme = createMuiTheme({
  footerHeight: 32,
  palette: {
    primary: blue,
    secondary: {
      main: pink['500']
    },
    background: {
      yellow: "#fffde7"
    }
  },
  status: {
    danger: 'orange',
  },
  typography: {
    fontFamily: [
      'Muli',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '42px',
      textAlign: 'center'
    },
    h2: {
      fontSize: '24px',
      textAlign: 'center'
    }
  }
});
theme = responsiveFontSizes(theme);
export default theme;
